var map = {
	"./37.png": "e75c",
	"./38.png": "c699",
	"./40.png": "5d03",
	"./41.png": "0144",
	"./42.png": "8b9d",
	"./about/qrcode.png": "6887",
	"./app.png": "ea62",
	"./business/address.png": "d73a",
	"./business/address1.png": "794a",
	"./business/address2.png": "d005",
	"./business/code1.png": "e9a8",
	"./business/code2.png": "c403",
	"./business/code3.png": "7dbe",
	"./business/code4.png": "eaf7",
	"./business/code5.png": "e31a",
	"./business/code6.png": "8965",
	"./business/next.png": "7fd0",
	"./business/phone.png": "d787",
	"./business/phone1.png": "a139",
	"./business/phone2.png": "f473",
	"./business/prev.png": "832e",
	"./dwell/fh_code_1.png": "1521",
	"./dwell/fh_code_2.png": "f769",
	"./dwell/fh_code_3.png": "acb2",
	"./dwell/fh_code_4.png": "4743",
	"./dwell/fh_code_5.png": "d2d9",
	"./dwell/fh_code_6.png": "e5c9",
	"./dwell/icon_1.png": "38b7",
	"./dwell/icon_2.png": "b7f8",
	"./dwell/icon_3.png": "99ba",
	"./dwell/icon_4.png": "7bda",
	"./dwell/icon_5.png": "5b4c",
	"./dwell/icon_6.png": "c1ad",
	"./dwell/icon_big.png": "b1ff",
	"./dwell/wl_code_1.png": "0b59",
	"./dwell/wl_code_2.png": "2a13",
	"./dwell/wl_v1.png": "a58f",
	"./dwell/wl_v2.png": "afed",
	"./dwell/wl_v3.png": "1ae4",
	"./dwell/wlx_code_1.png": "08f1",
	"./dwell/wlx_code_2.png": "ca5e",
	"./dwell/xg_code_1.png": "c7fc",
	"./exchange/1.png": "1843",
	"./exchange/2.png": "c70d",
	"./exchange/3.png": "daca",
	"./exchange/4.png": "f89b",
	"./exchange/arrow-right.png": "cad5",
	"./exchange/arrow_down.png": "f44d",
	"./exchange/arrow_down_active.png": "c9ea",
	"./exchange/code.png": "0b9a",
	"./exchange/code_icon.png": "5c9f",
	"./exchange/ditu.png": "c3c1",
	"./exchange/house1_icon.png": "2533",
	"./exchange/house2_icon.png": "c0fd",
	"./exchange/play.png": "2be2",
	"./exchange/poster1.png": "7bd2",
	"./exchange/poster2.png": "aa2a",
	"./footer/close.png": "bcf8",
	"./honor/bg.png": "086b",
	"./honor/left_arrow.png": "288a",
	"./honor/next_black_icon.png": "2269",
	"./honor/next_gray_icon.png": "8f38",
	"./honor/pre_black_icon.png": "1dbb",
	"./honor/pre_gray_icon.png": "7bdf",
	"./honor/right_arrow.png": "3367",
	"./hotel/aa.png": "cc40",
	"./hotel/banner_code.png": "573a",
	"./hotel/close.png": "3644",
	"./hotel/hotel1.png": "20ca",
	"./hotel/hotel1_1.png": "f3d2",
	"./hotel/hotel1_2.png": "36a5",
	"./hotel/hotel1_3.png": "8bef",
	"./hotel/hotel1_4.png": "243f",
	"./hotel/hotel1_min.png": "cd92",
	"./hotel/hotel2.png": "dde0",
	"./hotel/hotel2_1.png": "7ecd",
	"./hotel/hotel2_2.png": "4293",
	"./hotel/hotel2_3.png": "2e7a",
	"./hotel/hotel2_4.png": "9ee8",
	"./hotel/hotel2_min.png": "7138",
	"./hotel/hotel3_1.png": "ae9d",
	"./hotel/hotel3_2.png": "0e01",
	"./hotel/hotel3_3.png": "a3b4",
	"./hotel/hotel3_4.png": "c301",
	"./hotel/hotel3_min.png": "7cd9",
	"./hotel/hotel_1.png": "41eb",
	"./hotel/hotel_2.png": "da04",
	"./hotel/hotel_3.png": "82ed",
	"./hotel/icon_1.png": "3b10",
	"./hotel/icon_2.png": "b8fd",
	"./hotel/icon_3.png": "a35c",
	"./hotel/map2.png": "d269",
	"./hotel/play.png": "1958",
	"./hotel/slide11.png": "23dd",
	"./hotel/slide12.png": "c1b2",
	"./hotel/slide13.png": "26a0",
	"./hotel/slide14.png": "2db6",
	"./hotel/slide15.png": "b945",
	"./hotel/slide21.png": "fea6",
	"./hotel/slide22.png": "246e",
	"./hotel/slide23.png": "3f1f",
	"./hotel/slide24.png": "002c",
	"./hotel/slide25.png": "bc6c",
	"./join/fire.png": "0571",
	"./logo.png": "cf05",
	"./logo_top.png": "5f36",
	"./logobig.png": "80bc",
	"./myservice/1.png": "1712",
	"./myservice/2.png": "c562",
	"./myservice/28.png": "cfab",
	"./myservice/29.png": "bea6",
	"./myservice/3.png": "bd1a",
	"./myservice/30.png": "81d9",
	"./myservice/31.png": "2423",
	"./myservice/4.png": "7bcc",
	"./myservice/5.png": "ef9c",
	"./myservice/6.png": "527d",
	"./myservice/mincode.png": "6007",
	"./myservice/qrcode.png": "aec4",
	"./myservice/right.png": "d529",
	"./myservice/s1.png": "8c13",
	"./myservice/s2.png": "c068b",
	"./myservice/s3.png": "afbc",
	"./myservice/s4.png": "bdc3",
	"./myservice/to.png": "605e",
	"./news/0.png": "c4bd",
	"./news/1.png": "fd08",
	"./news/2.png": "205e",
	"./news/3.png": "ba47",
	"./news/arrow.png": "a424",
	"./news/en.png": "494e",
	"./news/jt_icon.png": "aade",
	"./news/search.png": "a06e",
	"./news/sx.png": "6532",
	"./nio/icon1.png": "14b0",
	"./nio/icon2.png": "0e0b",
	"./nio/icon3.png": "11d0",
	"./nio/icon4.png": "cd35",
	"./nio/icon5.png": "f1f3",
	"./nio/icon6.png": "c921",
	"./poster_0.png": "9ccf",
	"./poster_00.png": "3a87",
	"./poster_01.png": "5c55",
	"./poster_011.png": "c62a",
	"./poster_1.png": "11bc",
	"./poster_2.png": "e775",
	"./poster_3.png": "a970",
	"./poster_4.png": "cb24",
	"./poster_5.png": "a5c8",
	"./real/gh.png": "5840",
	"./real/gx.png": "b68e",
	"./real/honor_bg1.png": "27f4",
	"./real/honor_bg2.png": "b1c44",
	"./real/honor_bg3.png": "b7c2",
	"./real/honor_bg4.png": "9cbc",
	"./real/icon_pic.png": "d6a4",
	"./real/ll.png": "59cf",
	"./real/map_bg.png": "c1d4",
	"./real/phone_icon.png": "09e3",
	"./real/poster_1.png": "be18",
	"./real/qrcode.png": "7965",
	"./real/swiper1.png": "603f",
	"./real/swiper2.png": "1889",
	"./real/swiper3.png": "bd94",
	"./real/swiper4.png": "390d",
	"./real/swiper5.png": "d5bb",
	"./real/swiper6.png": "1d34",
	"./real/sy.png": "3680",
	"./real/zn.png": "9438",
	"./real/zx.png": "ce6d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";